<template>
  <v-defaults-provider :defaults="{ VIcon: { size: 20 } }">
    <v-navigation-drawer :rail="smallNav" permanent :order="200">
      <v-list color="primary" density="compact" nav :prepend-gap="16">
        <v-list-item v-if="!smallNav" :link="false" :ripple="false">
          <template #title>
            <span class="font-bold">{{ t("sidemenu.adminTitle") }}</span>
          </template>
        </v-list-item>
        <v-list-item
          prepend-icon="mdi-account-group"
          :title="t('sidemenu.supervisorOrgs')"
          :to="{ name: 'AdminSupervisorOrgs' }"
        />
        <v-list-item
          prepend-icon="mdi-folder-outline"
          :title="t('sidemenu.accounts')"
          :to="{ name: 'AdminAccounts' }"
        />
      </v-list>
      <template #append>
        <SideMenuFooter />
      </template>
    </v-navigation-drawer>
  </v-defaults-provider>

  <router-view></router-view>
</template>

<script lang="ts" setup>
import { useI18n } from "@/composables/useI18n";
import SideMenuFooter from "@/layouts/SideMenuFooter.vue";
import { useStorage } from "@vueuse/core";

const { t } = useI18n();
const smallNav = useStorage("use-small-nav", false);
</script>
